import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sms-intake-assist/artifacts/zu79u6p6_logo_AACA.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <img 
              src={LOGO_URL} 
              alt="Auto Accident Claim Assist" 
              className="h-20 w-auto"
            />
            <p className="text-slate-400 text-sm leading-relaxed">
              Helping South Carolina accident victims get the compensation they deserve. 
              Free case reviews with no obligation.
            </p>
          </div>

          {/* Contact Section */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Contact Us</h3>
            <div className="space-y-3">
              <a 
                href="tel:+18034030488" 
                className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4" />
                <span>+1 803-403-0488</span>
              </a>
              <a 
                href="mailto:brendan@autoaccidentclaimassist.com" 
                className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4" />
                <span>brendan@autoaccidentclaimassist.com</span>
              </a>
              <div className="flex items-center gap-2 text-slate-400">
                <MapPin className="w-4 h-4" />
                <span>South Carolina</span>
              </div>
            </div>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Legal</h3>
            <div className="space-y-3">
              <Link 
                to="/privacy-policy" 
                className="block text-slate-400 hover:text-white transition-colors"
                data-testid="footer-privacy-link"
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms-and-conditions" 
                className="block text-slate-400 hover:text-white transition-colors"
                data-testid="footer-terms-link"
              >
                Terms & Conditions
              </Link>
              <a 
                href="https://autoaccidentclaimassist.com/" 
                className="block text-slate-400 hover:text-white transition-colors"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-main-site-link"
              >
                Main Website
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm text-center sm:text-left">
              © {currentYear} Auto Accident Claim Assist. All rights reserved.
            </p>
            <div className="flex gap-4 text-sm">
              <Link to="/privacy-policy" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-privacy-link-bottom">
                Privacy
              </Link>
              <span className="text-slate-600">|</span>
              <Link to="/terms-and-conditions" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-terms-link-bottom">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
